import React from 'react';
import './UserDetailModal.css'; // Buat file CSS untuk styling modal

function UserDetailModal({ user, onClose }) {
    if (!user) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close-button" onClick={onClose}>&times;</button>
                <h3>Detail Pengguna: {user.name}</h3>
                <div className="user-info">
                    <p><strong>Email:</strong> {user.email}</p>
                    <p><strong>Nomor HP:</strong> {user.phone_number}</p>
                    <p><strong>Total Poin:</strong> {user.total_points}</p>
                    <p><strong>Member Sejak:</strong> {user.member_since}</p>
                </div>
                <hr />
                <h4>Statistik Aktivitas</h4>
                <div className="user-stats">
                    <div className="stat-item">
                        <span className="stat-value">{user.stats.claimed_rewards}</span>
                        <span className="stat-label">Reward Diklaim</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-value">{user.stats.point_transactions}</span>
                        <span className="stat-label">Transaksi Poin</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-value">{user.stats.completed_missions}</span>
                        <span className="stat-label">Misi Selesai</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserDetailModal;